import { ROUTE_PATH } from "@/common/constants/routing";
import {
  AppPermission,
  RepairOperationDto,
  RepairOperationItemDto,
  RepairOperationReferenceDto,
} from "@/core/api/generated/v1";

import {
  BaseEntityLink,
  BaseEntityLinkInheritableProps,
} from "../components/EntityLink/BaseEntityLink";
import RepairOperationInline from "./RepairOperationInline";

interface Props extends BaseEntityLinkInheritableProps {
  entity: RepairOperationDto | RepairOperationReferenceDto | null | undefined;
  entityId?: string | null;
  item?: RepairOperationItemDto;
  itemId?: string | null;
}

export default function RepairOperationLink({
  entity,
  entityId,
  item,
  itemId,
  inlineProps,
  ...otherProps
}: Props) {
  if (!entity && !entityId) {
    return null;
  }

  return (
    <BaseEntityLink
      entity={entity}
      entityId={entityId}
      permissions={[AppPermission.FleetAppAccess, AppPermission.RepairOperationRead]}
      to={ROUTE_PATH.REPAIR_OPERATION_VIEW(entity?.id || entityId || "")}
      content={
        <RepairOperationInline
          entity={entity}
          entityId={entityId}
          item={item}
          itemId={itemId}
          {...inlineProps}
        />
      }
      {...otherProps}
    />
  );
}
